export const NAME = 'locations';



// WEBPACK FOOTER //
// ./src/modules/locations/constants.js